export const getList = state => state.list;
export const getListData = state => state.list.data ? state.list.data : [];